import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const saleConsultation = createSlice({
	name: "saleConsultation",
	initialState: {
		loading: false,
        error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
			haveAssign: true,
		},
        items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const saleConsultationActions = saleConsultation.actions;
//Reducers
export const saleConsultationReducer = saleConsultation.reducer;
//Selectors
export const saleConsultationItemsSelector = (state) => state.saleConsultation.items;
export const saleConsultationLoadingSelector = (state) => state.saleConsultation.loading;
export const saleConsultationErrorSelector = (state) => state.saleConsultation.error;
export const saleConsultationFilterSelector = (state) => state.saleConsultation.filter;
export const saleConsultationPaginationSelector = (state) => state.saleConsultation.pagination;